import SiteNav from "@/pages/home/components/SiteNav";
import Hero from "@/pages/home/components/Hero";
import Ticker from "@/pages/home/components/Ticker";
import EvidenceEntrances from "@/pages/home/components/EvidenceEntrances";
import FeaturedStacks from "@/pages/home/components/FeaturedStacks";
import EventGroups from "@/pages/home/components/EventGroups";
import MaterialLibrary from "@/pages/home/components/MaterialLibrary";
import Timeline from "@/pages/home/components/Timeline";
import SubscribeBand from "@/pages/home/components/SubscribeBand";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <SiteNav />
      <main>
        <Hero />
        <Ticker />
        <EvidenceEntrances />
        <FeaturedStacks />
        <EventGroups />
        <MaterialLibrary />
        <Timeline />
        <SubscribeBand />
      </main>
      <SiteFooter />
    </div>
  );
}